<template>
  <div>
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <Nav />
    <router-view :encuestas="datosEncuesta" router-view/>
  </div>
</template>

<script>

import firebaseApp from "@/firebase/firebase.js";
import { getDatabase, ref, onValue } from "firebase/database";
import Catalogo from './components/Catalogo.vue'
import Nav from './components/shared/Nav.vue'

export default {
  name: 'App',
  data(){
    return{
      datosPop: {},
      datosEncuesta: {}
    }
  },
  components: {
    Catalogo,
    Nav
  },
  methods: {
    obtenerEncuestas() {
      const db = getDatabase();
      const dbRef = ref(db, "encuesta");
      //console.log(dbRef);
      try {
        onValue(
          dbRef,
          (snapshot) => {
            //console.log(snapshot);
            let encuestas = JSON.parse(JSON.stringify(snapshot));
            //console.log(encuestas);
            this.datosEncuesta = encuestas;
            
          },
          {
            onlyOnce: true,
          }
        )
      }catch(e){
        console.og(e);
      }
    },
  },
  created() {
    console.log("obtener");
    this.obtenerEncuestas();
  },
}
</script>

<style lang="scss">

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
 
</style>
